<h1 mat-dialog-title> Editar convenio colaboración </h1> <br/>

<mat-dialog-content>
    <form #proveedorForm=ngForm>
        <p>
            <mat-label>
                <h2> Convenio </h2>
            </mat-label>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> RUT </mat-label>

                <input name="rut" value="{{convenioColaboracion.rut}}" matInput [(ngModel)]="convenioColaboracion.rut" required pattern = "[0-9.]{7,10}[-]{1}[0-9Kk]{1}" placeholder = "Formato: 11111111-1" #rut="ngModel" />

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Nombre Proveedor </mat-label>

                <input name="nombre" value={{data.nombre}} matInput required [(ngModel)]="convenioColaboracion.nombre" #nombre="ngModel" (ngModelChange)="convenioColaboracion.nombre = $event.toUpperCase()" />


            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Razón Social </mat-label>

                <input name="razonSocial" id="razonSocial" value={{data.razonSocial}} matInput  [(ngModel)]="convenioColaboracion.razonSocial" (ngModelChange)="convenioColaboracion.razonSocial = $event.toUpperCase()" #razonSocial="ngModel" />

            </mat-form-field>
        </p>   

        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Región </mat-label>

                <mat-select name="region" #region="ngModel" [(ngModel)]="convenioColaboracion.idRegion">

                    <mat-option *ngFor="let region_ of this.data.regiones" [value]="region_.codigo">

                        {{region_.nombre}}

                    </mat-option>

                </mat-select>

            </mat-form-field>
        </p>
         <p>
            <mat-form-field appearance="outline" class="mat-input">
                <mat-label> Fecha Inicio </mat-label>
                <input name="fechaInicio" id="fechaInicio" matInput  type="date"    
                [(ngModel)]="convenioColaboracion.fechaInicio" required #fechaInicio="ngModel"  />
            </mat-form-field>
        </p>
       
   
        <p>
            <mat-form-field appearance="outline" class="mat-input">
                <mat-label>  Fecha Fin </mat-label>
                <input name="fechaFin" id="fechaFin" type="date"  matInput required [(ngModel)]="convenioColaboracion.fechaFin" (ngModelChange)="convenioColaboracion.fechaFin = $event.toUpperCase()" #fechaFin="ngModel" />
            </mat-form-field>
        </p>
 
        <p> 
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Descripción</mat-label>

                <textarea name="descripcion" id="descripcion" matInput required value={{data.descripcion}} [(ngModel)]="convenioColaboracion.descripcion" cols="55" rows="5" ></textarea>

            </mat-form-field>
        </p>  
        <!-- 
        <p> 
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Adjuntar </mat-label>
               
                <input name = "archivo" matInput [value] = "convenioColaboracion?.archivo?.name" disabled = "true" />
            </mat-form-field>
            <input #csvInput hidden = "true" type = "file" enctype = "multipart/form-data" onclick = "this.value = null" 
            (change) = "csvInputChange($event)" accept = "application/pdf, image/jpeg, image/jpg, image/png"/>

            <button mat-flat-button color = "primary" (click) = "csvInput.click()"> Seleccione Archivo (pdf,jpeg,jpg,png) </button>

        </p>   
         -->
        <p>
            <button class = "mat-raised-button btn-info" (click) = "onDescargarArchivosClick(convenioColaboracion.url)">
    
            <i class = "fa fa-download"> </i> Descargar Archivo Ingresado</button>
        </p>


    </form>
</mat-dialog-content> <br/>

<mat-dialog-actions>    
    <button  *ngIf="data.rol != 'ROLE_COORDINADOR'" mat-button class="mat-raised-button btn-success" (click)="onGuardarEdicionClick(proveedorForm)"> 
                <i class = "fa fa-plus"> </i> Guardar
            </button>

    <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()"> 
                <i class = "fa fa-trash"> </i> Salir
    </button>   
</mat-dialog-actions>